// Mock data for shop.ideamedia.org - will be replaced by backend API later

export const LOGO_URL = "/images/logo.png";

export const categories = [
  { id: 106, slug: "sviluppo-web-low-cost", name: { it: "Sviluppo siti web", en: "Website development" } },
  { id: 126, slug: "prestashop-plugins", name: { it: "Plugin Prestashop", en: "Prestashop plugins" } },
  { id: 200, slug: "programmazione", name: { it: "Programmazione", en: "Programming" } },
  { id: 246, slug: "custom-modules", name: { it: "Moduli custom", en: "Custom modules" } },
];

export const products = [
  {
    id: 11340,
    slug: "perfex-crm-bulk-files-client-manager",
    sku: "IDM-PFX001",
    name: { it: "Perfex CRM – Bulk files client manager", en: "Perfex CRM – Bulk Files Client Manager" },
    price: 19.9,
    regularPrice: 19.9,
    onSale: false,
    priceSuffix: { it: "/ anno", en: "/ year" },
    categories: ["custom-modules"],
    image: "/images/bulk-files.png",
    shortDescription: {
      it: "Modulo aggiuntivo per Perfex CRM che consente il download massivo dei file dei clienti: una funzionalità che fa risparmiare moltissimo tempo nella gestione quotidiana del CRM.",
      en: "Add-on module for Perfex CRM that enables bulk download of client files: a feature that saves a great deal of time in everyday CRM management.",
    },
    description: {
      it: "Questo modulo aggiuntivo per Perfex CRM permette di gestire in maniera massiva i file caricati dai clienti. È possibile selezionare quali file scaricare in blocco oppure scaricarli tutti insieme, risparmiando molto tempo: questa funzionalità infatti non è inclusa nella versione base di Perfex CRM.\n\nPerfex CRM consente di scaricare i file del cliente solo uno alla volta, rendendo l'operazione macchinosa e lunga in presenza di molti file. Con il modulo Bulk Files Manager è possibile comprimere e scaricare tutti i file in un'unica soluzione.",
      en: "This add-on module for Perfex CRM lets you manage files uploaded by your clients in bulk. You can select which files to download in a batch or download them all at once, saving a lot of time: this functionality is not included in the base version of Perfex CRM.\n\nPerfex CRM only allows downloading client files one at a time, which becomes slow and cumbersome when many files are involved. With the Bulk Files Manager module you can compress and download all files in a single operation.",
    },
  },
  {
    id: 11186,
    slug: "supporto-programmazione-api-crm-workflow",
    sku: "IDM-SUP003",
    name: { it: "Supporto programmazione API, CRM, customizzazione e sviluppo workflow", en: "API programming, CRM customization & workflow development support" },
    price: 50.0,
    regularPrice: 50.0,
    onSale: false,
    priceSuffix: { it: "/ ora", en: "/ hour" },
    categories: ["programmazione", "custom-modules"],
    image: "/images/zapier-workflow.png",
    shortDescription: {
      it: "Servizio di supporto per la configurazione di flussi automatici da e verso quasi tutti i CRM. Sviluppo e integrazione API, webhook, customizzazione e sviluppo software di automazione e workflow.",
      en: "Support service for configuring automated data flows to and from almost any CRM. API and webhook development and integration, customization and development of automation and workflow software.",
    },
    description: {
      it: "Supporto a tariffazione oraria per configurazione e creazione di workflow, programmazione API, CRM, customizzazione e sviluppo software. Con questo servizio è possibile creare qualsiasi flusso di dati automatico da e verso la maggior parte dei software compatibili.\n\nIl servizio è erogato da tecnici specializzati ed è possibile richiedere assistenza in remoto direttamente sul pc del cliente.",
      en: "Hourly-based support for workflow configuration and creation, API programming, CRM customization and software development. With this service you can build any automated data flow to and from most compatible software.\n\nThe service is delivered by specialized technicians and remote assistance directly on the customer's computer is also available.",
    },
  },
  {
    id: 9429,
    slug: "supporto-workflow-perfex-crm-zapier",
    sku: "IDM-SUP001",
    name: { it: "Supporto per creazione workflow Perfex CRM – Zapier.com", en: "Perfex CRM – Zapier.com workflow creation support" },
    price: 50.0,
    regularPrice: 50.0,
    onSale: false,
    priceSuffix: { it: "/ ora", en: "/ hour" },
    categories: ["programmazione", "custom-modules"],
    image: "/images/zapier-workflow.png",
    shortDescription: {
      it: "Servizio di supporto per la configurazione di flussi automatici da e verso Perfex CRM, utilizzando il nostro connettore Zapfex e la piattaforma Zapier.com.",
      en: "Support service for configuring automated flows to and from Perfex CRM, using our Zapfex connector and the Zapier.com platform.",
    },
    description: {
      it: "Supporto orario per configurazione e creazione di workflow da Perfex CRM a Zapier utilizzando anche il nostro modulo Zapfex. È prevista, se necessario, la connessione in modalità remota sul pc del cliente.\n\nCon questo servizio è possibile creare qualsiasi flusso di dati automatico da e verso Perfex CRM utilizzando Zapier.com.",
      en: "Hourly support for configuring and creating workflows from Perfex CRM to Zapier, also using our Zapfex module. Remote connection to the customer's computer is available if needed.\n\nWith this service you can create any automated data flow to and from Perfex CRM using Zapier.com.",
    },
  },
  {
    id: 8516,
    slug: "zapfex-modulo-sincronizzazione-zapier-perfexcrm",
    sku: "IDM-ZPF001",
    name: { it: "Zapfex – modulo sincronizzazione Zapier e PerfexCRM", en: "Zapfex – Zapier & PerfexCRM synchronization module" },
    price: 79.0,
    regularPrice: 79.0,
    onSale: false,
    priceSuffix: { it: "/ anno", en: "/ year" },
    categories: ["programmazione"],
    image: "/images/zapfex.png",
    shortDescription: {
      it: "Il modulo ZAPFEX collega completamente il tuo gestionale Perfex CRM al sistema Zapier per la sincronizzazione completa e la creazione di flussi di automazione.",
      en: "The ZAPFEX module fully connects your Perfex CRM to the Zapier ecosystem for complete synchronization and the creation of automation flows.",
    },
    description: {
      it: "Il modulo ZAPFEX – Zapier Perfex CRM Total Connector ti dà la possibilità di sincronizzare il tuo gestionale Perfex CRM con l'ecosistema Zapier creando vari flussi automatizzati.\n\nLa versione attuale del modulo supporta la sincronizzazione di: Potenziali clienti, Clienti, Progetti, Attività, Fatture e Ticket.\n\nLa sincronizzazione avviene sia in entrata che in uscita dal gestionale Perfex: puoi raccogliere i dati relativi alle entità ed esportarli verso le applicazioni collegate a Zapier, e viceversa importare in Perfex le informazioni provenienti dalle app presenti su Zapier.",
      en: "The ZAPFEX – Zapier Perfex CRM Total Connector module lets you synchronize your Perfex CRM with the Zapier ecosystem by creating various automated flows.\n\nThe current version of the module supports synchronization of: Leads, Customers, Projects, Tasks, Invoices and Tickets.\n\nSynchronization works both inbound and outbound: you can collect entity data and export it to the apps connected to Zapier, and conversely import information from Zapier apps into Perfex.",
    },
  },
  {
    id: 8155,
    slug: "prestashop-pagamento-dilazionato-rate-maxirata",
    sku: "IDM-PS002",
    name: { it: "Prestashop – pagamento dilazionato a rate e maxirata", en: "Prestashop – deferred payment with installments & balloon payment" },
    price: 39.0,
    regularPrice: 39.0,
    onSale: false,
    priceSuffix: null,
    categories: ["prestashop-plugins", "programmazione"],
    image: "/images/prestashop-rate.png",
    shortDescription: {
      it: "Il modulo Pagamento parziale / Credito / MaxiRata di PrestaShop ti dà la possibilità di concedere crediti e accettare pagamenti differiti nel tuo negozio, con piani di pagamento personalizzati.",
      en: "The PrestaShop Partial Payment / Credit / Balloon module lets you grant credit and accept deferred payments in your store, with customizable payment plans.",
    },
    description: {
      it: "Il modulo Pagamento parziale / Credito / MaxiRata di PrestaShop ti dà la possibilità di concedere crediti e accettare pagamenti differiti nel tuo negozio. Con questa estensione è possibile creare vari piani di pagamento a credito/rate e assegnarli a prodotti specifici, rendendo l'offerta disponibile a determinati clienti.\n\nIl modulo supporta le seguenti modalità di pagamento:\n• pagamento con acconto e saldo finale\n• pagamento dilazionato temporale\n• pagamento con acconto e rate\n• pagamento con acconto, attesa temporale e maxi rata finale",
      en: "The PrestaShop Partial Payment / Credit / Balloon module gives you the ability to grant credit and accept deferred payments in your shop. With this extension you can create different credit/installment payment plans and assign them to specific products, making the offer available to selected customers.\n\nThe module supports the following payment modes:\n• down payment with final balance\n• time-deferred payment\n• down payment plus installments\n• down payment, waiting period and final balloon payment",
    },
  },
  {
    id: 9438,
    slug: "supporto-installazione-configurazione-zapfex",
    sku: "IDM-SUP002",
    name: { it: "Supporto per installazione / configurazione workflow Zapfex – Perfex CRM", en: "Zapfex – Perfex CRM workflow installation / configuration support" },
    price: 99.0,
    regularPrice: 100.0,
    onSale: true,
    priceSuffix: null,
    categories: ["programmazione", "custom-modules"],
    image: "/images/support-hours.png",
    shortDescription: {
      it: "Supporto tecnico per installazione e configurazione workflow mediante modulo Zapfex – Perfex CRM, con possibilità di assistenza remota.",
      en: "Technical support for workflow installation and configuration via the Zapfex – Perfex CRM module, with remote assistance available.",
    },
    description: {
      it: "Supporto tecnico per installazione e configurazione di workflow mediante il modulo Zapfex – Perfex CRM. Possibilità di assistenza remota sul pc del cliente.\n\nProgrammazione e sviluppo di qualsiasi tipo di workflow su ZAPIER utilizzando il modulo Zapfex. Configurazione dell'automazione in base alle richieste del cliente.",
      en: "Technical support for installing and configuring workflows using the Zapfex – Perfex CRM module. Remote assistance on the customer's computer is available.\n\nProgramming and development of any kind of workflow on ZAPIER using the Zapfex module. Automation configured according to the customer's requirements.",
    },
  },
  {
    id: 5399,
    slug: "crm-gestionale-personalizzabile",
    sku: "IDM-CRM001",
    name: { it: "CRM – Gestionale personalizzabile fatture preventivi clienti", en: "CRM – Customizable management system for invoices, quotes & clients" },
    price: 150.0,
    regularPrice: 150.0,
    onSale: false,
    priceSuffix: null,
    categories: ["programmazione"],
    image: "/images/crm.png",
    shortDescription: {
      it: "CRM IdeaMedia GEST completo di moltissime funzionalità e personalizzabile completamente in base alle esigenze aziendali. Compatibile mobile e intuitivo da utilizzare.",
      en: "IdeaMedia GEST CRM packed with features and fully customizable to your business needs. Mobile compatible and intuitive to use.",
    },
    description: {
      it: "CRM IdeaMedia GEST completo di moltissime funzionalità e personalizzabile completamente in base alle esigenze aziendali. Completamente compatibile mobile e intuitivo da utilizzare.\n\nGestionale costruito con framework moderno, con possibilità di ampliamento e personalizzazione, integrazione con APP e compatibilità mobile al 100%.\n\nTra le funzionalità principali: gestione clienti, preventivi, fatture, progetti, attività, ticket di supporto e report dettagliati.",
      en: "IdeaMedia GEST CRM packed with features and fully customizable to your business needs. Fully mobile compatible and intuitive to use.\n\nManagement system built on a modern framework, with the possibility of expansion and customization, APP integration and 100% mobile compatibility.\n\nMain features include: client management, quotes, invoices, projects, tasks, support tickets and detailed reports.",
    },
  },
  {
    id: 2579,
    slug: "prestashop-modulo-localizzazione-magazzino",
    sku: "IDM-PS001",
    name: { it: "Prestashop modulo localizzazione prodotto in magazzino", en: "Prestashop warehouse product location module" },
    price: 35.0,
    regularPrice: 35.0,
    onSale: false,
    priceSuffix: null,
    categories: ["prestashop-plugins"],
    image: "/images/warehouse.jpg",
    shortDescription: {
      it: "Modulo di localizzazione del prodotto in magazzino. Permette la gestione avanzata del magazzino con la geolocalizzazione del prodotto divisa in 4 campi: corsia, scaffale, ripiano e posizione.",
      en: "Warehouse product location module. Enables advanced warehouse management with product geolocation split into 4 fields: aisle, rack, shelf and position.",
    },
    description: {
      it: "Modulo di localizzazione del prodotto in magazzino per Prestashop.\n\nPermette la gestione avanzata del magazzino, con la geolocalizzazione del prodotto divisa in 4 campi:\n• Corsia\n• Scaffale\n• Ripiano\n• Posizione\n\nGrazie a questo modulo la preparazione degli ordini diventa molto più rapida: l'operatore sa esattamente dove trovare ogni prodotto all'interno del magazzino.",
      en: "Warehouse product location module for Prestashop.\n\nIt enables advanced warehouse management, with product location split into 4 fields:\n• Aisle\n• Rack\n• Shelf\n• Position\n\nThanks to this module, order preparation becomes much faster: the operator knows exactly where to find each product inside the warehouse.",
    },
  },
  {
    id: 2339,
    slug: "sito-web-professional",
    sku: "IDM-WEB003",
    name: { it: "Sito web Professional", en: "Professional website" },
    price: 1490.0,
    regularPrice: 1490.0,
    onSale: false,
    priceSuffix: null,
    categories: ["sviluppo-web-low-cost"],
    image: "/images/sito-pro.jpg",
    shortDescription: {
      it: "Servizio di sviluppo sito Professional low cost: sito web composto da 20 pagine (home, chi siamo, prodotti, servizi, contatti e sottopagine) con grafica personalizzata.",
      en: "Low cost Professional website development service: a 20-page website (home, about us, products, services, contacts and subpages) with custom graphics.",
    },
    description: {
      it: "Servizio di sviluppo sito Professional low cost.\n\nDescrizione dell'offerta:\n• Sviluppo sito web composto da 20 pagine (home, chi siamo, prodotti, servizi, contatti e sottopagine)\n• Grafica personalizzata e design responsive per tutti i dispositivi\n• Ottimizzazione SEO di base per i motori di ricerca\n• Form di contatto e integrazione social\n• Pannello di amministrazione per la gestione autonoma dei contenuti\n• Assistenza e formazione iniziale inclusa",
      en: "Low cost Professional website development service.\n\nOffer description:\n• Development of a 20-page website (home, about us, products, services, contacts and subpages)\n• Custom graphics and responsive design for all devices\n• Basic SEO optimization for search engines\n• Contact form and social media integration\n• Admin panel for independent content management\n• Initial assistance and training included",
    },
  },
  {
    id: 2336,
    slug: "sito-web-medium",
    sku: "IDM-WEB002",
    name: { it: "Sito web Medium", en: "Medium website" },
    price: 890.0,
    regularPrice: 890.0,
    onSale: false,
    priceSuffix: null,
    categories: ["sviluppo-web-low-cost"],
    image: "/images/sito-medium.jpg",
    shortDescription: {
      it: "Servizio di sviluppo sito web Medium low cost: sito composto da 10 pagine (home, chi siamo, prodotti, servizi, contatti e sottopagine) con grafica personalizzata.",
      en: "Low cost Medium website development service: a 10-page website (home, about us, products, services, contacts and subpages) with custom graphics.",
    },
    description: {
      it: "Servizio di sviluppo sito web Medium low cost.\n\nDescrizione dell'offerta:\n• Sviluppo sito web medium composto da 10 pagine (home, chi siamo, prodotti, servizi, contatti e sottopagine)\n• Grafica personalizzata e design responsive\n• Ottimizzazione SEO di base\n• Form di contatto\n• Pannello di amministrazione per la gestione autonoma dei contenuti",
      en: "Low cost Medium website development service.\n\nOffer description:\n• Development of a 10-page medium website (home, about us, products, services, contacts and subpages)\n• Custom graphics and responsive design\n• Basic SEO optimization\n• Contact form\n• Admin panel for independent content management",
    },
  },
  {
    id: 2330,
    slug: "sito-web-basic",
    sku: "IDM-WEB001",
    name: { it: "Sito web Basic", en: "Basic website" },
    price: 450.0,
    regularPrice: 450.0,
    onSale: false,
    priceSuffix: null,
    categories: ["sviluppo-web-low-cost"],
    image: "/images/sito-basic.jpg",
    shortDescription: {
      it: "Sviluppo sito web low cost BASIC: sito web personalizzato con 5 pagine (home, chi siamo, prodotti, servizi, contatti) e grafica personalizzata.",
      en: "Low cost BASIC website development: custom 5-page website (home, about us, products, services, contacts) with custom graphics.",
    },
    description: {
      it: "Sviluppo sito web low cost BASIC.\n\nDescrizione offerta:\n• Sviluppo sito web personalizzato con 5 pagine (Home, chi siamo, prodotti, servizi, contatti)\n• Grafica personalizzata e design responsive\n• Form di contatto\n• Ottimizzazione di base per i motori di ricerca\n• Soluzione ideale per piccole attività che vogliono essere presenti online",
      en: "Low cost BASIC website development.\n\nOffer description:\n• Custom website development with 5 pages (Home, about us, products, services, contacts)\n• Custom graphics and responsive design\n• Contact form\n• Basic search engine optimization\n• The ideal solution for small businesses that want an online presence",
    },
  },
];

export const translations = {
  it: {
    home: "Home",
    shop: "Shop",
    cart: "Carrello",
    checkout: "Checkout",
    contact: "Contatti",
    agency: "Agenzia",
    services: "Servizi",
    portfolio: "Portfolio",
    heroTitle: "IDEAMEDIA",
    heroSubtitle: "LE TUE IDEE ONLINE",
    heroCta: "CHIEDI CONSIGLIO",
    shopTitle: "Shop plugin e moduli software",
    featuredProducts: "Prodotti in evidenza",
    ourCategories: "Le nostre categorie",
    allCategories: "Tutte le categorie",
    addToCart: "Aggiungi al carrello",
    addedToCart: "Prodotto aggiunto al carrello",
    viewProduct: "Vedi prodotto",
    sale: "Offerta",
    category: "Categoria",
    categories: "Categorie",
    tag: "Tag",
    tags: "Tag",
    sku: "COD",
    description: "Descrizione",
    documentation: "Documentazione",
    relatedProducts: "Prodotti correlati",
    quantity: "Quantità",
    emptyCart: "Il tuo carrello è vuoto.",
    returnToShop: "Torna allo shop",
    product: "Prodotto",
    price: "Prezzo",
    subtotal: "Subtotale",
    total: "Totale",
    remove: "Rimuovi",
    cartTotals: "Totale carrello",
    proceedToCheckout: "Procedi al checkout",
    billingDetails: "Dettagli di fatturazione",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Indirizzo email",
    phone: "Telefono",
    address: "Indirizzo",
    city: "Città",
    zip: "CAP",
    country: "Paese",
    yourOrder: "Il tuo ordine",
    placeOrder: "Effettua ordine e paga",
    orderSuccess: "Grazie! Il tuo ordine è stato ricevuto.",
    orderNumber: "Numero ordine",
    backToHome: "Torna alla home",
    searchPlaceholder: "Cerca prodotti...",
    results: "risultati",
    result: "risultato",
    showingAll: "Visualizzazione di tutti i",
    footerTagline: "Agenzia web | comunicazione, marketing e sviluppo software",
    footerRights: "Tutti i diritti riservati",
    requiredField: "Campo obbligatorio",
    continueShopping: "Continua lo shopping",
    secureCheckout: "Pagamento sicuro",
    vatIncluded: "IVA inclusa",
    paymentNote: "Il pagamento verrà elaborato in modo sicuro.",
  },
  en: {
    home: "Home",
    shop: "Shop",
    cart: "Cart",
    checkout: "Checkout",
    contact: "Contact",
    agency: "Agency",
    services: "Services",
    portfolio: "Portfolio",
    heroTitle: "IDEAMEDIA",
    heroSubtitle: "YOUR IDEAS ONLINE",
    heroCta: "ASK FOR ADVICE",
    shopTitle: "Software plugins and module shop",
    featuredProducts: "Featured products",
    ourCategories: "Our categories",
    allCategories: "All categories",
    addToCart: "Add to cart",
    addedToCart: "Product added to cart",
    viewProduct: "View product",
    sale: "Sale",
    category: "Category",
    categories: "Categories",
    tag: "Tag",
    tags: "Tags",
    sku: "SKU",
    description: "Description",
    documentation: "Documentation",
    relatedProducts: "Related products",
    quantity: "Quantity",
    emptyCart: "Your cart is currently empty.",
    returnToShop: "Return to shop",
    product: "Product",
    price: "Price",
    subtotal: "Subtotal",
    total: "Total",
    remove: "Remove",
    cartTotals: "Cart totals",
    proceedToCheckout: "Proceed to checkout",
    billingDetails: "Billing details",
    firstName: "First name",
    lastName: "Last name",
    email: "Email address",
    phone: "Phone",
    address: "Address",
    city: "City",
    zip: "ZIP code",
    country: "Country",
    yourOrder: "Your order",
    placeOrder: "Place order & pay",
    orderSuccess: "Thank you! Your order has been received.",
    orderNumber: "Order number",
    backToHome: "Back to home",
    searchPlaceholder: "Search products...",
    results: "results",
    result: "result",
    showingAll: "Showing all",
    footerTagline: "Web agency | communication, marketing and software development",
    footerRights: "All rights reserved",
    requiredField: "Required field",
    continueShopping: "Continue shopping",
    secureCheckout: "Secure checkout",
    vatIncluded: "VAT included",
    paymentNote: "Payment will be processed securely.",
  },
};

export const formatPrice = (value) =>
  `${value.toFixed(2).replace(".", ",")}€`;
